import { Entity, Field } from 'typegraph';

import { IEntry } from 'common/entities/courseWrapper/CourseWrapper';
import LaunchURL from 'common/entities/LaunchURL';
import GroupDiscount from './GroupDiscount';
import Product from './Product';
import Subscription from './Subscription';
import EntryVariant from './EntryVariants';

@Entity({one: "entry", many: "entries"})
export default class Entry implements IEntry {

	@Field()
	public id: string;

	@Field()
	public displayName: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Subscription})
	public subscription: Subscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

	@Field({entity: GroupDiscount})
	public groupDiscount: GroupDiscount;

	@Field({entity: EntryVariant})
	public variants: EntryVariant[];
}



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/Entry.ts